export const companyColumns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '赠品名称',
    dataIndex: 'name',
  },
  {
    title: '对应产品',
    dataIndex: 'link_products',
  },
  {
    title: '赠品附件',
    dataIndex: 'attach_doc_info_list',
    scopedSlots: { customRender: 'attach_doc_info_list' },
  },
  {
    title: '说明',
    dataIndex: 'summary',
  },
  {
    title: '状态',
    customRender: (record)=> record.data.status===1?'启用':'禁用',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const serviceColumns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '合作机构',
    dataIndex: 'company_id',
  },
  {
    title: '赠品名称',
    dataIndex: 'name',
  },
  {
    title: '对应产品',
    dataIndex: 'link_products',
  },
  {
    title: '资料附件',
    dataIndex: 'attach_doc_info_list',
    scopedSlots: { customRender: 'attach_doc_info_list' },
  },
  {
    title: '说明',
    dataIndex: 'summary',
  },
  {
    title: '状态',
    customRender: (record)=> record.status===1?'启用':'禁用',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const companyFormData = [
  {
    name: 'name',
    lable: '赠品名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'link_products',
    lable: '对应产品',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'upload',
    lable: '资料附件',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'summary',
    lable: '说明',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
];
